import React, { useEffect } from "react";
import styled from "styled-components";

const SearchBoxWrapper = styled.div`
  position: ${(props) => (props.length > 0 ? "absolute" : "relative")};
  top: ${(props) => (props.length > 0 ? "24px" : "-5px")};
  left: ${(props) => (props.length > 0 ? "25px" : 0)};
  z-index: 999;
  .gx-lt-icon-search-bar-lg {
    width: 200px !important;
  }
  .gx-lt-icon-search-bar-lg input[type="search"] {
    height: 38px !important;
    padding: 5px 18px 5px 40px !important;
  }
  .gx-search-bar .gx-search-icon {
    top: 1px;
    height: 38px;
    line-height: 40px;
  }
  @media (max-width: 575.98px) {
    position: relative;
    top: 0;
    left: 0;
    .gx-lt-icon-search-bar-lg {
      width: 100% !important;
    }
  }
`;

const SearchBox = ({
  value,
  styleName,
  placeholder,
  onChange,
  length,
  searchText,
  setSearchText,
}) => {
  // const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setSearchText(value);
  }, [value]);

  return (
    <SearchBoxWrapper length={length}>
      <div className={`gx-search-bar ${styleName}`}>
        <div className="gx-form-group">
          <input
            className="ant-input"
            type="search"
            placeholder={placeholder}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              onChange(e.target.value);
            }}
          />
          <span className="gx-search-icon gx-pointer">
            <i className="icon icon-search" />
          </span>
        </div>
      </div>
    </SearchBoxWrapper>
  );
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: "",
  value: "",
};
